import { Button, Input, H2, P } from '@driftt/tide-core-legacy'
import { Link } from 'react-router'

import LoadingDots from 'components/shared/LoadingDots'

import Domain from './Domain'

import './style.styl'


const DKIMEmailComponent = ({
  onAddDomainClick,
  isLoading,
  isCreatingDomain,
  sendFromDomain,
  sendFromEmail,
  onSendFromEdit,
  onSaveDomain,
  onCancelDomain,
  domainCreateSuccess,
  domainCreateFail,
  sendingDomains,
  domainCreateLoading,
  domainCreateFailNoUser
}) => (
  <div>
    <Link to="/settings/conversations">&lt; Conversations</Link>
    <div>
      <div className="dkim-settings-header">
        <H2>Email Sending Domains</H2>
        <P>Authenticate your domains with Drift by modifying your domain's DNS records. These changes allow your campaigns to appear to come from your email domain, instead of from our servers. After you've made the required DNS changes, please wait 24-48 hours for the changes to propagate. <Link href="https://help.drift.com/article/email-sending-domains">Why should I do this?</Link></P>
      </div>
      <div>
        {isLoading &&
          <span className="dkim-loading-domains">Loading your email domains <LoadingDots /></span>
        }
        {!isLoading &&
          <div>
            <div>{sendingDomains.map(domain => <Domain key={domain} whitelabel={domain} />)}</div>
            {isCreatingDomain &&
              <DKIMDomainCreate
                onSendFromEdit={onSendFromEdit}
                sendFromDomain={sendFromDomain}
                sendFromEmail={sendFromEmail}
                onSaveDomain={onSaveDomain}
                onCancelDomain={onCancelDomain}
                domainCreateLoading={domainCreateLoading}
                domainCreateSuccess={domainCreateSuccess}
                domainCreateFail={domainCreateFail}
                domainCreateFailNoUser={domainCreateFailNoUser}
              />
            }
            <Button disabled={isCreatingDomain} onClick={onAddDomainClick} type="secondary">Add Domain</Button>
          </div>
        }
      </div>
    </div>
  </div>
)

const DKIMDomainCreate = ({
  sendFromEmail,
  sendFromDomain,
  onSendFromEdit,
  onSaveDomain,
  onCancelDomain,
  domainCreateLoading,
  domainCreateSuccess,
  domainCreateFail,
  domainCreateFailNoUser,
}) => (
  <div className="dkim-domain-container dkim-domain-container-active">
    <div className="dkim-domain-entry dkim-domain-entry-active">
      <div className="dkim-domain-entry-title">
        <span className="dkim-domain-entry-status-dot"></span>
        {!!sendFromDomain ?
          <p className="dkim-domain-entry-name">{sendFromDomain}</p>
          :
          <p className="dkim-domain-entry-name-placeholder"><em>new domain</em></p>
        }
      </div>
    </div>
    <div className="dkim-domain-content">
      <label>Example email to send from</label>
      <Input type="email" value={sendFromEmail} onChange={onSendFromEdit} placeholder="me@mydomain.com" />
      <div>
        {domainCreateSuccess &&
          <p className="dkim-domain-create-success">Successfully created sending domain</p>
        }
        {domainCreateFail &&
          <p className="dkim-domain-create-fail">Domain could not be created</p>
        }
        {domainCreateFailNoUser &&
          <p className="dkim-domain-create-fail">Domain could not be created -- there is no user on the account with that domain name.</p>
        }
      </div>
      <div className="dkim-domain-edit-actions">
        <Button loading={domainCreateLoading} disabled={!sendFromDomain || domainCreateLoading} onClick={onSaveDomain}>Save</Button>
        <Button onClick={onCancelDomain} type="secondary">Cancel</Button>
      </div>
    </div>
  </div>
)


export default DKIMEmailComponent



// WEBPACK FOOTER //
// ./src/scripts/components/settings/DKIMEmailSettings/component.js